import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.CurrencySwitcher', {
    title: 'Display Currency',
    placeholder: 'Select currency',
    resetButtonTitle: 'Reset',
});
